import {createDataStore} from './createDataStore';

// Caches /data/scipyData.json for the SciPy tutorial pages.
// See createDataStore for the fetch-once / persist-to-localStorage behaviour.
export const useScipyDataStore = createDataStore(
    '/data/scipyData.json',
    'scipy-data-store',
    ['slugs', 'nextPage', 'relatedPages', 'suggestedCourses']
);
